var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-3xl"},[_c('div',{staticClass:"m-5 shadow p-3 rounded"},[(_vm.newInstrumentNumber)?_c('v-instrument-form'):_c('v-new-number')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }